import React from "react"

const iconPerformance = () => (
  <svg
    width="18"
    height="12"
    viewBox="0 0 18 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.6174 10.9718L9.21443 9.56883C8.99892 9.35332 8.99892 9.0031 9.21443 8.78759L10.6174 7.38466C10.8329 7.16914 11.1831 7.16914 11.3986 7.38466L12.8015 8.78759C13.017 9.0031 13.017 9.35332 12.8015 9.56883L11.3986 10.9718C11.1831 11.1873 10.8329 11.1873 10.6174 10.9718Z"
      stroke="#747474"
      strokeWidth="0.75"
      strokeMiterlimit="10"
    />
    <path
      d="M4.97667 10.9718L3.57375 9.56883C3.35823 9.35332 3.35823 9.0031 3.57375 8.78759L4.97667 7.38466C5.19219 7.16914 5.5424 7.16914 5.75792 7.38466L7.16085 8.78759C7.37636 9.0031 7.37636 9.35332 7.16085 9.56883L5.75792 10.9718C5.54448 11.1873 5.19426 11.1873 4.97667 10.9718Z"
      stroke="#747474"
      strokeWidth="0.75"
      strokeMiterlimit="10"
    />
    <path
      d="M6.58062 8.20525L3.80378 5.42841C3.54889 5.17352 3.13651 5.17352 2.88369 5.42841L1 7.3121"
      stroke="#747474"
      strokeWidth="0.75"
      strokeMiterlimit="10"
    />
    <path
      d="M12.298 8.28196L8.64877 4.6327C8.39388 4.37781 7.98357 4.37781 7.72868 4.6327L4.53946 7.82192"
      stroke="#747474"
      strokeWidth="0.75"
      strokeMiterlimit="10"
    />
    <path
      d="M10.1946 7.80534L17 1"
      stroke="#747474"
      strokeWidth="0.75"
      strokeMiterlimit="10"
    />
    <path
      d="M15.0852 1H16.8487C16.9316 1 17 1.06838 17 1.15128V2.91478"
      stroke="#747474"
      strokeWidth="0.75"
      strokeMiterlimit="10"
    />
  </svg>
)

export { iconPerformance }
